import React from 'react';

const AchievementsSection = () => {
  const achievements = [
    {
      year: "2013-2014",
      title: "Leo of the World",
      recipient: "Leo Krishnaratha",
      description: "First Leo of the World from our club, making all Leos of Sri Lanka proud"
    },
    {
      year: "2014-2015",
      title: "Leo of the World",
      recipient: "Leo Sanjeevan",
      description: "Second consecutive Leo of the World - a rare achievement in Leo history"
    },
    {
      year: "2021-2022",
      title: "Leo of the Year",
      recipient: "Leo Maheshwaran",
      description: "District recognition for outstanding leadership and service"
    },
    {
      year: "2022-2023",
      title: "Leo of the Year",
      recipient: "Leo Nithushan",
      description: "Continued excellence in leadership and community impact"
    }
  ];

  const clubAwards = [
    {
      title: "Most Outstanding Club",
      count: "15+",
      description: "District 306B2 recognition multiple years"
    },
    {
      title: "Excellence Awards",
      count: "5+",
      description: "Lions Clubs International recognition"
    },
    {
      title: "Best Admin Club",
      count: "Multiple",
      description: "Administrative excellence recognition"
    },
    {
      title: "Project Awards",
      count: "200+",
      description: "Individual project recognitions"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Awards & <span className="text-primary">Recognition</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our commitment to excellence has been recognized at district, national, and international levels, 
            setting benchmarks for Leo clubs worldwide.
          </p>
        </div>

        {/* Individual Achievements */}
        {/* <div className="mb-20">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Individual Excellence</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {achievements.map((achievement, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <div className="text-center">
                  <div className="w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-white font-bold text-xl">🏆</span>
                  </div>
                  <div className="text-sm text-primary font-semibold mb-2">{achievement.year}</div>
                  <h4 className="text-xl font-bold text-gray-900 mb-2">{achievement.title}</h4>
                  <p className="text-secondary font-semibold mb-3">{achievement.recipient}</p>
                  <p className="text-gray-600 text-sm leading-relaxed">{achievement.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Club Achievements */}
        <div>
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Club Recognition</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {clubAwards.map((award, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                <div className="text-center">
                  <div className="text-4xl font-bold text-primary mb-2">{award.count}</div>
                  <h4 className="text-xl font-bold text-gray-900 mb-3">{award.title}</h4>
                  <p className="text-gray-600 text-sm">{award.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Special Recognition */}
        <div className="mt-20 bg-gradient-to-r from-primary to-secondary rounded-3xl p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-6">International Recognition</h3>
          <p className="text-xl mb-8 max-w-4xl mx-auto">
            As the only club from Sri Lanka to receive multiple Excellence Awards from Lions Clubs International, 
            we've set a standard of service that inspires Leo clubs across the globe.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="text-3xl font-bold mb-2">Only Club</div>
              <div className="text-white/90">From Sri Lanka with multiple international awards</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">Global Impact</div>
              <div className="text-white/90">Projects spanning across 9 countries</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">Benchmark</div>
              <div className="text-white/90">Setting standards for Leo clubs worldwide</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;